export default __webpack_public_path__ + "f83b48fe304c87fb5edb1af8240bc3dd.svg";